type Type = {
  AEROBICS: "Aerobics";
  BADMINTON: "Badminton";
  BASEBALL: "Baseball";
  BASKETBALL: "Basketball";
  BODYBUILDING: "Bodybuilding";
  BOWLING: "Bowling";
  BOXING: "Boxing";
  CALISTHENICS: "Calisthenics";
  CRICKET: "Cricket";
  CROSSFIT: "Crossfit";
  CYCLING: "Cycling";
  DANCING: "Dancing";
  DARTS: "Darts";
  FOOTBALL: "Football";
  FUTSAL: "Futsal";
  GOLF: "Golf";
  HIIT: "HIIT";
  HIKING: "Hiking";
  HOCKEY: "Hockey";
  MARTIAL_ARTS: "Martial Arts";
  MEDITATION: "Meditation";
  MINI_SOCCER: "Mini Soccer";
  PADEL: "Padel";
  PICKLEBALL: "Pickleball";
  PILATES: "Pilates";
  POOL: "Pool";
  POWERLIFTING: "Powerlifting";
  ROCK_CLIMBING: "Rock Climbing";
  ROWING: "Rowing";
  RUGBY: "Rugby";
  RUNNING: "Running";
  SKATEBOARDING: "Skateboarding";
  SPIN_CYCLING: "Spin Cycling";
  SQUASH: "Squash";
  SURFING: "Surfing";
  SWIMMING: "Swimming";
  TABLE_TENNIS: "Table Tennis";
  TAI_CHI: "Tai Chi";
  TENNIS: "Tennis";
  VOLLEYBALL: "Volleyball";
  WALKING: "Walking";
  WEIGHT_TRAINING: "Weight Training";
  YOGA: "Yoga";
  ZUMBA: "Zumba";
};

export const SportTypes = {
  AEROBICS: "Aerobics",
  BADMINTON: "Badminton",
  BASEBALL: "Baseball",
  BASKETBALL: "Basketball",
  BODYBUILDING: "Bodybuilding",
  BOWLING: "Bowling",
  BOXING: "Boxing",
  CALISTHENICS: "Calisthenics",
  CRICKET: "Cricket",
  CROSSFIT: "Crossfit",
  CYCLING: "Cycling",
  DANCING: "Dancing",
  DARTS: "Darts",
  FOOTBALL: "Football",
  FUTSAL: "Futsal",
  GOLF: "Golf",
  HIIT: "HIIT",
  HIKING: "Hiking",
  HOCKEY: "Hockey",
  MARTIAL_ARTS: "Martial Arts",
  MEDITATION: "Meditation",
  MINI_SOCCER: "Mini Soccer",
  PADEL: "Padel",
  PICKLEBALL: "Pickleball",
  PILATES: "Pilates",
  POOL: "Pool",
  POWERLIFTING: "Powerlifting",
  ROCK_CLIMBING: "Rock Climbing",
  ROWING: "Rowing",
  RUGBY: "Rugby",
  RUNNING: "Running",
  SKATEBOARDING: "Skateboarding",
  SPIN_CYCLING: "Spin Cycling",
  SQUASH: "Squash",
  SURFING: "Surfing",
  SWIMMING: "Swimming",
  TABLE_TENNIS: "Table Tennis",
  TAI_CHI: "Tai Chi",
  TENNIS: "Tennis",
  VOLLEYBALL: "Volleyball",
  WALKING: "Walking",
  WEIGHT_TRAINING: "Weight Training",
  YOGA: "Yoga",
  ZUMBA: "Zumba"
};

export type SportType =
  | Type["AEROBICS"]
  | Type["BADMINTON"]
  | Type["BASEBALL"]
  | Type["BASKETBALL"]
  | Type["BODYBUILDING"]
  | Type["BOWLING"]
  | Type["BOXING"]
  | Type["CALISTHENICS"]
  | Type["CRICKET"]
  | Type["CROSSFIT"]
  | Type["CYCLING"]
  | Type["DANCING"]
  | Type["DARTS"]
  | Type["FOOTBALL"]
  | Type["FUTSAL"]
  | Type["GOLF"]
  | Type["HIIT"]
  | Type["HIKING"]
  | Type["HOCKEY"]
  | Type["MARTIAL_ARTS"]
  | Type["MEDITATION"]
  | Type["MINI_SOCCER"]
  | Type["PADEL"]
  | Type["PICKLEBALL"]
  | Type["PILATES"]
  | Type["POOL"]
  | Type["POWERLIFTING"]
  | Type["ROCK_CLIMBING"]
  | Type["ROWING"]
  | Type["RUGBY"]
  | Type["RUNNING"]
  | Type["SKATEBOARDING"]
  | Type["SPIN_CYCLING"]
  | Type["SQUASH"]
  | Type["SURFING"]
  | Type["SWIMMING"]
  | Type["TABLE_TENNIS"]
  | Type["TAI_CHI"]
  | Type["TENNIS"]
  | Type["VOLLEYBALL"]
  | Type["WALKING"]
  | Type["WEIGHT_TRAINING"]
  | Type["YOGA"]
  | Type["ZUMBA"];

// Sport categorization helper functions

// Team sports with multiple players competing together
export const TEAM_SPORTS = [
  SportTypes.BASKETBALL,
  SportTypes.FOOTBALL,
  SportTypes.FUTSAL,
  SportTypes.MINI_SOCCER,
  SportTypes.VOLLEYBALL,
  SportTypes.BASEBALL,
  SportTypes.CRICKET,
  SportTypes.RUGBY,
  SportTypes.HOCKEY
];

// Racket/paddle sports (usually 1v1 or 2v2)
export const RACKET_SPORTS = [
  SportTypes.TENNIS,
  SportTypes.BADMINTON,
  SportTypes.SQUASH,
  SportTypes.TABLE_TENNIS,
  SportTypes.PADEL,
  SportTypes.PICKLEBALL
];

// Combat sports (1v1 competitive)
export const COMBAT_SPORTS = [
  SportTypes.BOXING,
  SportTypes.MARTIAL_ARTS
];

// Individual competitive sports (can have matches/tournaments)
export const COMPETITIVE_INDIVIDUAL_SPORTS = [
  SportTypes.RUNNING,
  SportTypes.CYCLING,
  SportTypes.SWIMMING,
  SportTypes.GOLF,
  SportTypes.BOWLING,
  SportTypes.DARTS,
  SportTypes.POOL,
  SportTypes.ROWING,
  SportTypes.ROCK_CLIMBING,
  SportTypes.SURFING,
  SportTypes.SKATEBOARDING,
  SportTypes.HIKING,
  SportTypes.WALKING
];

// Fitness/wellness activities (classes/sessions, not competitive matches)
export const WELLNESS_ACTIVITIES = [
  SportTypes.YOGA,
  SportTypes.PILATES,
  SportTypes.MEDITATION,
  SportTypes.AEROBICS,
  SportTypes.ZUMBA,
  SportTypes.HIIT,
  SportTypes.TAI_CHI,
  SportTypes.DANCING,
  SportTypes.WEIGHT_TRAINING,
  SportTypes.BODYBUILDING,
  SportTypes.POWERLIFTING,
  SportTypes.CALISTHENICS,
  SportTypes.SPIN_CYCLING,
  SportTypes.CROSSFIT
];

// Utility functions
export const isTeamSport = (sportType: SportType): boolean => {
  return TEAM_SPORTS.includes(sportType);
};

export const isRacketSport = (sportType: SportType): boolean => {
  return RACKET_SPORTS.includes(sportType);
};

export const isCombatSport = (sportType: SportType): boolean => {
  return COMBAT_SPORTS.includes(sportType);
};

export const isCompetitiveIndividualSport = (sportType: SportType): boolean => {
  return COMPETITIVE_INDIVIDUAL_SPORTS.includes(sportType);
};

export const isWellnessActivity = (sportType: SportType): boolean => {
  return WELLNESS_ACTIVITIES.includes(sportType);
};

export const canHaveMatches = (sportType: SportType): boolean => {
  return !isWellnessActivity(sportType);
};
